class LayoutEventsHelpers {
    debounceEvent = (callback, time) => {
        let timeout;
        return (...args) => {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                callback.apply(context, args);
            }, time);
        };
    };

    throttleEvent = (callback, time) => {
        let wait = false;
        return (...args) => {
            if (!wait) {
                callback.apply(this, args);
                wait = true;
                setTimeout(() => {
                    wait = false;
                }, time);
            }
        };
    };

    optimizeEvent = (callback, time) => {
        const newTime = Math.floor(time / 3);
        return this.debounceEvent(this.throttleEvent(callback, newTime), newTime * 2);
    };
}

const layoutEventsHelpers = new LayoutEventsHelpers();
export default layoutEventsHelpers;